<!--
 * @Author: Wangchaoke
 * @Date: 2019-11-18 15:48:22
 * @LastEditTime: 2022-09-20 11:24:41
 * @Description: 主要用于哈佛视频的视频播放组件，基于西瓜视频封装 官网地址:http://h5player.bytedance.com
 * 西瓜视频QQ群：772199450 西瓜视频插件作者：815743082 有问题可以进QQ群沟通或者联系作者
 * @FilePath: /xingmahui_front/src/components/activity/harvard/HFVideo.vue
 -->
<template>
  <div
    id="HFVideo"
    v-if="videoDetail"
    @touchmove="touchMoveFn"
    @mousewheel="mouseWheelFn"
  >
    <!-- 西瓜视频DOM Begin -->
    <Xgplayer
      id="HF"
      :config="Videoconfig"
      @player="Player = $event"
      :class="startStyle"
    />
    <!-- 西瓜视频DOM Over -->

    <!-- 分享解锁视频 Begin -->
    <div v-if="videoDetail.locked" id="shareVideo">
      <p v-if="!isGoLogin" v-html="videoDetail.lockedDes"></p>
      <p v-if="isGoLogin">登录观看飞鹤哈佛育儿视频</p>
      <div @click="HFshare(true)" v-if="!isGoLogin">
        <img
          src="./../../../assets/images/activity/harvard/share1.png"
          alt=""
        />
        <span>分享</span>
      </div>
      <div v-if="isGoLogin" @click="isLogin">
        <span>登录</span>
      </div>
    </div>
    <!-- 分享解锁视频 Over -->

    <!-- 网络是否为Wifi Begin -->
    <div v-if="!isWifi && !videoDetail.locked" class="bg">
      <div :class="isHfindex ? 'wifi' : 'wifidetail'">
        <p>正在使用非WIFI网络</p>
        <p>
          <span>视频总长 {{
              videoDetail.videoDuration.split(':')[0] >= 10 ? videoDetail.videoDuration.split(':')[0] : '0' + videoDetail.videoDuration.split(':')[0]
            }}:
            {{
              videoDetail.videoDuration.split(':')[1] >= 10 ? videoDetail.videoDuration.split(':')[1] : '0' + videoDetail.videoDuration.split(':')[1]
            }}
          </span>
          <span>流量约{{ videoDetail.videoSize }}M</span>
        </p>
        <div id="playVideo" @click="playVideoStart()">
          <img
            src="./../../../assets/images/activity/harvard/playVideo.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 网络是否为Wifi Over -->

    <!-- 分享引导 Begin -->
    <HFshare ref="HFshareVideo"></HFshare>
    <!-- 分享引导 Over -->
  </div>
</template>

<style lang="less" scoped>
@import './../../../assets/less/harvard.less';

#HFVideo {
  height: 216px;
  width: 100%;

  position: relative;
  // 哈佛视频样式
  #HF {
    width: 100% !important;
    height: 100% !important;
    background-size: 100% 100%;
    background-position: center center;
    z-index: 10;
  }

  /deep/ .xgplayer-progress-cache {
    background: hsla(0, 0%, 100%, 0.1);
  }

  /deep/ .xgplayer-progress-played {
    background-image: linear-gradient(-90deg, #fff, #fff);
  }

  /deep/ .xgplayer-progress-outer {
    height: 2px;
  }

  .videoDisPlayer {
    /deep/ .xgplayer-start {
      display: none !important;
    }
  }

  // 微信分享可观看视频
  #shareVideo {
    position: absolute;
    z-index: 88;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    text-align: center;

    p {
      font-size: @fontSize12;
      font-weight: 400;
      color: #fff;
      line-height: 18px;
      padding-top: 63px;
    }

    div {
      width: 90px;
      height: 34px;
      font-size: @fontSize14;
      background: linear-gradient(90deg,
      rgba(255, 220, 133, 1) 0%,
      rgba(241, 201, 92, 1) 100%);
      box-shadow: 0px 2px 8px -2px rgba(233, 189, 68, 0.78);
      border-radius: 21px;
      line-height: 34px;
      text-align: center;
      margin: 0 auto;
      margin-top: 8px;
      color: rgba(255, 255, 255, 1);
      color: #fff;

      img {
        width: 15px;
        height: 15px;
        vertical-align: middle;
        padding-right: 5px;
      }

      span {
        position: relative;
        top: 1px;
      }
    }
  }

  // 主页wifi 样式
  .wifi {
    position: absolute;
    z-index: 9999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    text-align: center;

    p:nth-child(1) {
      font-size: @fontSize12;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 14px;
      padding-top: 53px;
    }

    p:nth-child(2) {
      font-size: 10px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 12px;
      padding-top: 5px;

      span:nth-child(1) {
        padding-right: 10px;
      }
    }

    div {
      width: 26px;
      padding-top: 11px;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  // 详情页视频样式
  .bg {
    position: absolute;
    z-index: 88;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;

    .wifidetail {
      position: absolute;
      z-index: 9999;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      text-align: center;

      p:nth-child(1) {
        font-size: @fontSize16;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 14px;
        padding-top: 62px;
      }

      p:nth-child(2) {
        font-size: @fontSize12;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 12px;
        padding-top: 10px;

        span:nth-child(1) {
          padding-right: 10px;
        }
      }

      div {
        width: 36px;
        padding-top: 18px;
        margin: 0 auto;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>

<script>
/**
 * 判断是否在微信中
 */
import {getCookie, globalGoLogin, is_weixin} from "@/assets/js/common.js";
/**
 * 接口Api
 */
import API from "@/utils/axiosApi/harvardApi";
import {addIntegral, inquireTime} from "@/utils/newMemberApiGlobal"
/**
 * 哈佛视频插件
 */
import Xgplayer from 'xgplayer-vue'
/**
 * 分享引导
 */
import HFshare from '@/components/contents/HFshare.vue'

export default {
  name: 'HFVideo',
  data() {
    return {
      Videoconfig: {},//播放器配置
      Player: null,//播放器实例
      isShare: false,//是否显示分享
      isWifi: true,//判断网络是否为wifi / 是WIFI:true  / 4G:false
      readingArticleDuration: 10
    }
  },
  created() {
    inquireTime(data => {
      this.readingArticleDuration = data.readingArticleDuration
    },this)
  },
  props: ['videoDetail', 'isHfindex', 'isGoLogin', 'CRMID', 'memberLevel', 'isPreventFlag', "currentTopicList", 'isFoods'],
  watch: {
    /**
     * @description: 用于监听父级组件传过数据重新创建视频标签
     * @param {type} urlVideo 视频详情信息
     */
    videoDetail: {
      immediate: true,//这句重要
      deep: true,//深监听
      handler (newValue) {
        /**
         * @description: nextTick用于让Dom加载完再调用视频创建方法，解决视频拿不到Dom白屏问题；
         * @param {type} newValue 视频详情信息
         */
        if (newValue) {
          if (this.$store.state.isWifi) {
            this.isWifi = this.$store.state.isWifi
          } else {
            this.isWifiFun()
          }
          this.$nextTick(function () {
            this.createVideo(newValue)
          })
        }
      }
    }
  },
  computed: {
    // 计算视频带不带播放按钮
    startStyle() {
      if (!this.isWifi && !this.videoDetail.locked) {
        return 'xgplayer xgplayer-mobile xgplayer-skin-default lang-is-en  xgplayer-playing xgplayer-inactive xgplayer-pause videoDisPlayer'
      } else {
        return 'xgplayer xgplayer-mobile xgplayer-skin-default xgplayer-pause  lang-is-en xgplayer-playing'
      }
    },
    fomattertime (val) {
      return val.split(':')[0] > 10 ? val.split(':')[0] : '0' + val.split(':')[0];
    }
  },
  methods: {
    touchMoveFn: function (e) {
      if (this.isPreventFlag) {
        e.preventDefault()
      } else {
      }
    },
    mouseWheelFn: function (e) {
      if (this.isPreventFlag) {
        e.preventDefault()
      } else {
      }
    },
    /**
     * @description: 未登录下点击登录跳转登录界面
     */
    isLogin() {
      // 哈佛视频详情页-视频浮层登录GIO埋点
      globalGoLogin()
    },
    /**
     * @description:创建视频实例
     * @param {type} newValue 视频详情配置
     */
    createVideo (newValue) {
      const { videoUrl, videoImg, locked } = newValue;
      if (videoUrl) {
        let self = this
        /**
         * 安卓下不显示视频控件
         **/
        let u = navigator.userAgent
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端

        /**
         * 视频切换为防止重新创建Dom
         **/
        // 背景图取消
        $('#HF').css('background-image', '')
        // 关闭上次监听视频播放的时间
        $('video').off('timeupdate')
        // 如果有视频实例则不需要重新创建，直接切换地址
        if (this.Player) {
          // 解决安卓被劫持后，切换视频地址没有poster黑屏问题
          this.Player.pause()
          $('video').css('display', 'none')
          $('#HF').css(
            'background-image',
            'url(' + this.videoDetail.videoImg + ')'
          )
          $('.xgplayer-controls').css('opacity', '0')

          // 切换视频地址
          this.Player.src = videoUrl
          // 切换视频封面
          this.Player.poster = videoImg
          // 判断是不是带锁，是不是4G网络如果是
          if (!locked && this.isWifi) {
            $('.bg').css('background-image', '')
            this.$nextTick(() => {
              // 记录播放的时间实现记忆性播放功能 并且判断当前是不是静音状态
              if (!this.Player.muted) {
                this.setPlayerVideo(self, locked, isAndroid, !this.Player.muted)
              } else {
                this.setPlayerVideo(self, locked, isAndroid)
              }
            })
          } else {
            this.Player.pause()
            // 处理安暂停不带poster图片的情况
            this.$nextTick(() => {
              $('video').css('display', 'none')
              $('.bg').css(
                'background-image',
                'url(' + this.videoDetail.videoImg + ')'
              )
            })
          }
        } else {
          /**
           * 播放器配置
           **/
          this.Videoconfig = {
            id: 'HF', //元素id
            url: videoUrl, //视频地址
            poster: videoImg, //图片
            fitVideoSize: 'fixWidth',
            fitVideoSize: 'fixHeight',
            playsinline: true, //设置ios全屏问题
            'x5-video-player-type': 'h5-page', //解决ios安卓播放自动全屏问题
            'x5-video-player-fullscreen': true, //解决自动全屏问题
            'x5-video-orientation': 'portraint', //横竖屏
            closeVideoClick: true, //禁止pc点击屏幕暂停（功能与现实相反）
            closeVideoTouch: true, //禁止手机点击屏幕暂停（功能与现实相反）
            ignores: ['enter', 'mobile', 'error'], //去掉loadding
            loop: true, //循环播放
            whitelist: ['iPhone', 'Android'], //白名单（支持个别机型）
            hasStart: true,
          }
          this.$nextTick(() => {
            if (!locked && self.isWifi) {
              $('.bg').css('background-image', '')
              this.setPlayerVideo(self, locked, isAndroid, !this.Player.muted)
            } else {
              self.Player.pause()
              if (!this.isHfindex) {
                $('.bg').css(
                  'background-image',
                  'url(' + this.videoDetail.videoImg + ')'
                )
              }
            }
          })
        }
      } else {
        // 处理安卓带锁没有poster问题
        $('#shareVideo').css('background-image', '')
        // 清除上次监听视频播放的时间
        $('video').off('timeupdate')
        // 没有视频连接代表没权限 展示分享
        $('#HF').css('background-image', 'url(' + videoImg + ')')
        if (this.Player) {
          this.Player.destroy(true)
          this.Player = null
        }
      }
    },
    /**
     * @description:监听播放视频状态存到本地方法
     * @param {type} self:this locked:是否带锁 isAndroid:是否是安卓 muted:是否静音
     */
    setPlayerVideo(self, locked, isAndroid, muted) {
      var that = this
      /**
       *  当前视频的id
       * */
      let fn_video_id = Number(location.pathname.replace(/[^0-9]/gi, ''))
      /**
       *  获取本地视频播放的时间
       * */
      let localcurrentTime = JSON.parse(localStorage.getItem('currentTime'))
        ? JSON.parse(localStorage.getItem('currentTime'))
        : {}
      // 新增视频唯一时间对象
      localcurrentTime.hasOwnProperty(fn_video_id)
        ? localcurrentTime
        : (localcurrentTime[fn_video_id] = 0)

      // 判断视频有没有开始播放 有控件的情况下不播放不会实例化video标签
      self.Player.once('playing', () => {
        let times = true;//观看视频积分任务
        let videoState = true;//判断视频是否播放完
        // 开始播放视频图片清空，并把控制器展示出来
        $('#HF').css('background-image', '')
        $('.xgplayer-controls').css('opacity', '1')
        // 首页视频判断问题
        if (this.isHfindex) {
          self.Player.on('requestFullscreen', function () {
            $('#HF').css('background-color', '#000')
          })
          self.Player.on('exitFullscreen', function () {
            $('#HF').css('background-color', '#FFDF00')
          })
        }
        /**
         *  设置当前视频上次播放的时间
         * */
        let current = Number(localcurrentTime[fn_video_id])
        self.Player.currentTime = current
        $('video').currentTime = current
        /**
         *  实时更新当前视频播放时间存到本地
         * */
        $('video').on("timeupdate", () => {
          this.currentTimebug = $('video')[0] && Math.floor($('video')[0].currentTime) || 0;
          localcurrentTime[fn_video_id] = this.currentTimebug;
          window.localStorage.setItem("currentTime", JSON.stringify(localcurrentTime));

          // 先导片不加积分
          if (!this.isHfindex) {
            // 观看视频 10 秒添加积分
            if (current + this.readingArticleDuration == this.currentTimebug && times) {
              times = false;
              addIntegral({
                taskGroupCode: "YDWZ00002",
                crmId: this.CRMID
              }, this, '播放视频任务完成')
            }
          }
          // 视频观看完成通知后台观看完成
          if (this.currentTimebug + 1 == Math.floor($('video')[0].duration) && videoState) {
            var gradeName = self.memberLevel ? self.memberLevel.grade.name : "未登录";
            videoState = false;
            // 先导片id
            let HFindex = 3238
            // 视频观看完成请求后台
            API.watchFinish(
              {},
              {
                crm_id: this.CRMID,
                fnVideoId: fn_video_id != 0 ? fn_video_id : HFindex,
              }
            )
          }
        })
        /**
         *  判断当前是否静音
         * */
        if (!muted) {
          self.$toast({
            duration: 1000,
            message: '当前为静音模式播放',
            context: self,
          })
        }
      })
      self.Player.on('pause', () => {
        const id = Number(location.pathname.replace(/[^0-9]/gi, '')) //当前视频的id
        const num = this.currentTimebug
        const total = Math.floor($('video')[0].duration)
        const percent = Math.round((num / total) * 10000) / 10000.0
        sensors.track('VideoBroadcast', {
          content_id: id,
          content_title: this.videoDetail.videoTitle,
          author: '',
          length_of_time: total,
          content_topic: this.currentTopicList.topicTitle,
          page_name: this.$route.meta.title,
          video_duration: this.currentTimebug,
          rate_of_progress: percent.toFixed(2),
          is_counted: percent >= 0.8,
          is_finished: num == total,
          position:
            this.currentTopicList.harvardVideos.findIndex(
              (item) => item.fnVideoId === id
            ) + 1,
        })
      })
      self.Player.on('play', function () {
        var gradeName = self.memberLevel
          ? self.memberLevel.grade.name
          : '未登录'

      })
    },
    /**
     * @description: 点击播放视频
     * @param {type} isWifi 把网络提示关闭
     * @return:
     */
    playVideoStart() {
      // 关闭上次监听视频播放的时间
      $('video').off('timeupdate')
      let self = this
      /**
       * 安卓下不显示视频控件
       **/
      let u = navigator.userAgent
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      $('.bg').css('background-image', '')
      this.Player.start(this.videoDetail.videoUrl)
      this.Player.play()
      this.setPlayerVideo(
        self,
        this.videoDetail.locked,
        isAndroid,
        !this.Player.muted
      )
      this.$nextTick(() => {
        $('video').css('display', 'block')
      })
      this.isWifi = true
      this.$store.commit('changeWifi', true)
    },
    /**
     * @description: 判断网络是否为wifi
     * @param {type} isWifi 网络状态
     * @return: isWifi 网络状态
     */
    isWifiFun () {
      let network_state = '';
      let ua = window.navigator.userAgent;
      let con = window.navigator.connection;
      // 如果是微信
      if (/MicroMessenger/.test(ua)) {
        // 如果是微信6.0以上版本，用UA来判断
        if (/NetType/.test(ua)) {
          var type = ua.match(/NetType\/(\S*)/)
          network_state = type[1]
          // 如果是微信6.0以下版本，调用微信私有接口WeixinJSBridge
        } else {
          document.addEventListener("WeixinJSBridgeReady", function onBridgeReady() {
            WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
              network_state = e.err_msg;
            });
          });
        }
        // 如果支持navigator.connection
      } else if (con) {
        var network = con.type
        network_state = network
      }
      if (network_state == 'WIFI') {
        this.isWifi = true
      } else if (network_state == undefined) {
        this.isWifi = true
      } else {
        this.$store.commit('changeWifi', false)
        this.isWifi = false
      }
    },
    /**
     * @description: 点击弹出分享引导
     * @param {type} HFshareVideo Dom
     * @return: null
     */
    HFshare(state) {
      if (state) {
        // 哈佛视频详情页-视频浮层分享GIO埋点
        if (this.memberLevel) {
          gio('track', 'hafovideopage_videoshare', { 'member_level': this.memberLevel.grade.name });
        } else {
          gio('track', 'hafovideopage_videoshare', { 'member_level': "未登录" });
        }
        this.$refs.HFshareVideo.showShareVideo()
      }
    },
    is_weixin,
    getCookie,
  },
  components: {
    HFshare,
    Xgplayer,
  },
}
</script>
